import PropTypes from "prop-types";

export const DynamicLevelItem = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  value: PropTypes.number,
  color: PropTypes.string,
});
